<template>
  <modal
    @close="$emit('close')"
    :showCloseButton="false"
    classes="w-4/5 lg:w-11/12 mx-auto overflow-auto pb-4 max-w-96 lg:max-w-5xl pt-0 shadow-none"
  >
    <img @click="$emit('close')" src="@/assets/SVG/cross-partners.svg" class="hidden lg:block absolute text-white pin-t mr-4 mt-4 cursor-pointer text-xl z-50 h-4 cross-desktop" style="right:130px">
    <img @click="$emit('close')" src="@/assets/SVG/cross-partners.svg" class="lg:hidden absolute text-white mr-4 mt-4 cursor-pointer text-xl z-50 h-4" style="right:-5px;top:25px">
    <!-- mobile -->
    <carousel
      class="w-full raiting-carousel lg:hidden pt-8"
      :perPage="1"
      :navigationEnabled="true"
      :centerMode="true"
      :speed="1000"
      :paginationColor="'#ffffff'"
      :paginationActiveColor="'#ffce42'"
      navigationNextLabel=" "
      navigationPrevLabel=" "
      :spacePadding="0"
      :loop="false"
    >
      <slide v-for="(slide, index) in slides" :key="index" class=" bg-white px-6">
        <div class="mt-8 h-64 flex justify-center">
          <img class="w-full" :src="require(`@/assets/${slide.imageMobile}.png`)" alt="" />
        </div>
        <div>
                  <div class="mt-3 px-0">
          <h2 class="text-main-text font-bold" style="font-size:16px">{{ slide.name }}</h2>
          <p class="text-main-text text-xs md:text-sm mt-1" v-html="slide.description"></p>
        </div>
        <div class="flex px-0 mt-3 mb-4 w-full">
          <p class="text-additional-text text-sm font-bold w-1/2">
            Необходимые баллы
          </p>
          <p class="points w-1/2 text-xl font-bold py-2">{{ slide.points }}</p>
        </div>
        </div>
      </slide>
    </carousel>

    <!-- desktop -->

    <carousel
      class="raiting-carousel hidden lg:block"
      :perPage="1"
      :navigationEnabled="true"
      :centerMode="true"
      :paginationColor="'#ffffff'"
      :paginationActiveColor="'#ffce42'"
      navigationNextLabel=" "
      navigationPrevLabel=" "
      :spacePadding="0"
      :loop="false"
    >
      <slide v-for="(slide, index) in slides" :key="index">
        <div class="w-full flex overflow-hidden bg-white" style="height:500px;border-radius:10px;">
          <div style="max-width:480px;width:40%">
            <img style="border-radius: 10px 0 0 10px;" class="h-full" :src="require(`@/assets/${slide.imageDesktop}.png`)" alt="" />
          </div>

          <div class="pl-8 pt-6 relative" style="width:60%">
            <img :src="require(`@/assets/SVG/${slide.logo}.svg`)" alt="" />
            <h1 class="text-main-text text-4xl font-bold" style="max-width:200px">{{ slide.name }}</h1>
            <div  class="text-main-text text-lg mt-8 leading-tight" v-html="slide.description"></div>

            <div style="position:absolute;bottom:40px">
              <p class="text-additional-text text-lg font-bold w-64">
                Необходимые баллы
              </p>
              <p class="points w-full text-4xl font-bold py-1 px-16 mt-3">
                {{ slide.points }}
              </p>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </modal>
</template>

<script>
import modal from '@/views/modals/new-base-modal.vue';
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    modal,
    Carousel,
    Slide,
  },
  data() {
    return {
      slides: [
        {
          name: 'Каменная стая',
          description:
            "<p>Молодые энергичные ребята. Действуют спонтанно,<br class='hidden lg:block'> доверяя чутью и интуиции. Им просто нравится <br class='hidden lg:block'>проводить время вместе.</p>",
          imageMobile: 'rating-page-slider-mobile-1',
          logo: 'rating-rang-1',
          imageDesktop: 'rating-page-slider-desktop-1',
          points: '100',
        },
        {
          name: 'Железная банда',
          description:
            "<p>Амбициозные ребята. У них немного опыта, <br class='hidden lg:block'>но горящие глаза. Обожают рисковать и всегда <br class='hidden lg:block'>ставят галки, ведь можно урвать неплохой куш.</p>",
          imageMobile: 'rating-page-slider-mobile-2',
          logo: 'rating-rang-2',
          imageDesktop: 'rating-page-slider-desktop-2',
          points: '250',
        },
        {
          name: 'Бронзовое братство',
          description:
            "<p>Матерая группировка. Делают все сообща. Два раза <br class='hidden lg:block'>подумают перед тем, как совершить какое-либо <br class='hidden lg:block'>действие.</p>",
          imageMobile: 'rating-page-slider-mobile-3',
          logo: 'rating-rang-3',
          imageDesktop: 'rating-page-slider-desktop-3',
          points: '500',
        },
        {
          name: 'Серебряный клан',
          description:
            "<p>Сложившийся коллектив, в котором у каждого есть <br class='hidden lg:block'>своя роль. На них равняются. Они – эталон.</p>",
          imageMobile: 'rating-page-slider-mobile-4',
          logo: 'rating-rang-4',
          imageDesktop: 'rating-page-slider-desktop-4',
          points: '1000',
        },
        {
          name: 'Золотой альянс',
          description:
            "<p>На их стороне опыт. Сами решают, в какие битвы <br class='hidden lg:block'>ввязываться, а какие выигрывать.</p>",
          imageMobile: 'rating-page-slider-mobile-5',
          logo: 'rating-rang-5',
          imageDesktop: 'rating-page-slider-desktop-5',
          points: '3000',
        },
        {
          name: 'Бриллиантовая федерация',
          description:
            "<p>Они не просто команда. Это маленькое государство <br class='hidden lg:block'>со своими правилами и законами.</p>",
          imageMobile: 'rating-page-slider-mobile-6',
          logo: 'rating-rang-6',
          imageDesktop: 'rating-page-slider-desktop-6',
          points: '6000',
        },
      ],
    };
  },
};
</script>

<style scoped>
* {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
}
.points {
  background: #ffce42;
  color: #333333;
  display: grid;
  place-content: center;
  border-radius: 25px;
}
.raiting-carousel{
  width: 87%;
}
.raiting-carousel >>> .VueCarousel-dot-container{
    margin-top: 0 !important;
}
.raiting-carousel >>> .VueCarousel-wrapper{
  border-radius: 10px;
}
.raiting-carousel >>> .VueCarousel-navigation {
  position: absolute;
  width: 106%;
  top: 42% !important;
  right: -3% !important;
  transform: none;
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
}

.raiting-carousel >>> .VueCarousel-navigation button {
  margin: 0 !important;
  transform: none;
  position: relative;
  background: white;
  background-image: url(../../../assets/SVG/arrow-right.svg);
  background-repeat: no-repeat;
  background-size: 75%;
  background-position: center;
  border-radius: 50%;
  margin-right: auto;
  height: 32px;
  width: 32px;
  outline: none;
}
.raiting-carousel >>> .VueCarousel-navigation .VueCarousel-navigation-prev {
  transform: rotate(180deg);
}

@media only screen and (min-width: 1240px){
  /* .cross-desktop{
    right: 100px im !important;
  } */
 .raiting-carousel{
  width: 80%;
  min-width: 892px;
 }
.raiting-carousel >>> .VueCarousel-navigation {
  position: absolute;
  width: 100%;
  top: 92% !important;
  right: 0% !important;
  transform: none;
  display: flex;
  justify-content:space-between;
}
.raiting-carousel >>> .VueCarousel-navigation .VueCarousel-navigation-prev {
  position: absolute;
  top: -250px;
  left: -7%;
}
.raiting-carousel >>> .VueCarousel-navigation .VueCarousel-navigation-next {
  position: absolute;
  top: -250px;
  right: -7%;
}
}
@media only screen and (max-width: 1370px){
  .cross-desktop{
    right: 100px !important;
  }
}
@media only screen and (max-width: 1320px){
  .cross-desktop{
    right: 80px !important;
  }
}
@media only screen and (max-width: 1285px){
  .cross-desktop{
    right: 60px !important;
  }
}

</style>
